import { useEffect, useState } from 'react';

/**
 * Wert, der einer schnellen Eingabe verzögert folgt.
 *
 * Lag bis 18.08.2026 in useZabbixIntegration - ein generischer Helfer hat in
 * einem Integrations-Modul nichts verloren, und die Live-Vorschau des
 * Mail-Editors braucht ihn genauso. Dort bleibt ein Re-Export stehen, damit
 * bestehende Importe nicht brechen.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
